/* Coria · Anunta-ma cand revine in stoc (comutator cf_restock_live).
   Formularul apare doar la variantele epuizate (logica temei). La trimitere, in loc de
   formularul de contact, cererea merge la serverul Coria (/restock), care trimite un singur
   email cand produsul revine in stoc si are link de dezabonare. */
(function () {
  var s = document.currentScript;
  var URL_BASE = ((s && s.getAttribute('data-url')) || 'https://icy-morning-0dac.laurentiumediapress.workers.dev').replace(/\/+$/, '');
  var MSG = {
    ok: 'Gata. Iti scriem o singura data, cand produsul revine in stoc.',
    already_subscribed: 'Esti deja pe lista. Iti scriem cand revine in stoc.',
    already_in_stock: 'Vesti bune: produsul e deja in stoc. Reincarca pagina.',
    consent_required: 'Bifeaza acordul ca sa te anuntam.',
    invalid_email: 'Verifica adresa de email.',
    rate_limited: 'Prea multe incercari. Mai incearca peste cateva minute.',
    product_not_found: 'Nu am gasit produsul. Scrie-ne la contact@coria.ro.',
    error: 'Nu am putut salva cererea. Mai incearca o data sau scrie-ne la contact@coria.ro.'
  };
  function clientId() {
    try { var k = 'cf_cid', v = localStorage.getItem(k); if (!v) { v = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); localStorage.setItem(k, v); } return v; } catch (e) { return ''; }
  }
  function say(form, text, good) {
    var m = form.querySelector('.cf-restock-msg'); if (!m) return;
    m.textContent = text; m.hidden = false; m.classList.toggle('is-ok', !!good);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeType !== 1 || !form.classList || !form.classList.contains('stock-notify__form')) return;
    if (!form.querySelector('[name="cf_handle"]')) return; // comutatorul e oprit: ramane formularul vechi
    e.preventDefault();
    var email = (form.querySelector('[name="contact[email]"]') || {}).value || '';
    var consent = form.querySelector('[name="cf_consent"]');
    if (consent && !consent.checked) { say(form, MSG.consent_required); consent.focus(); return; }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var title = (form.querySelector('[name="contact[Product Title]"]') || {}).value || '';
    fetch(URL_BASE + '/restock', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email.trim(),
        consent: true,
        handle: form.querySelector('[name="cf_handle"]').value,
        title: title,
        query: title,
        website: (form.querySelector('[name="cf_website"]') || {}).value || '',
        clientId: clientId()
      })
    }).then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
      .then(function (d) {
        var st = (d && d.status) || (d && d.ok ? 'ok' : 'error');
        var good = !!(d && d.ok) || st === 'already_subscribed';
        say(form, MSG[good && st !== 'already_subscribed' ? 'ok' : st] || (d && d.error) || MSG.error, good);
        if (good) { form.classList.add('is-done'); try { if (window.dataLayer) dataLayer.push({ event: 'coria_restock_signup' }); } catch (x) {} }
      })
      .catch(function () { say(form, MSG.error); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }, true);
})();
